import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/workload-manager/tasks/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/workload-manager/tasks/list',
            params,
            replace: true,
        });
    },
});
